import { GoogleMapsShutdownController } from './controllers/google-maps-shutdown.controller';
import { GoogleMapsController } from './controllers/google-maps.controller';
import { GoogleMapsConfig } from './models/google-maps.config';

export namespace GoogleMapsState {
  export abstract class Spec {}

  export class Init extends Spec {}

  export class Loading extends Spec {
    constructor(readonly config: GoogleMapsConfig) {
      super();
    }
  }

  export class Shutdown extends Spec {}

  export class Ready extends Spec {
    constructor(
      public readonly controller: GoogleMapsController,
      public readonly shutdownController: GoogleMapsShutdownController
    ) {
      super();
    }
  }
}
